import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { ApiVersionService } from './footer/services/api-version.service';
import { MainComponent } from './main/main.component';

@NgModule({
    imports:
    [
        CommonModule,
        FormsModule
    ],
    declarations:
    [
        HeaderComponent,
        FooterComponent,
        MainComponent
    ],
    providers: [
        ApiVersionService
    ],
    exports:
    [
        HeaderComponent,
        FooterComponent,
        MainComponent
    ]
})
export class LayoutModule { }





// WEBPACK FOOTER //
// /opt/snt/front-end-turnos/src/app/layout/layout.module.ts